import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { AbilityKindsQuery as AbilityKindsQueryType } from "./__generated__/AbilityKindsQuery";

const AbilityKindsQuery = loader("./AbilityKindsQuery.gql");

type AbilityKindsQueryProviderType = (props: { children: (data: AbilityKindsQueryType) => ReactNode }) => ReactElement;

export const AbilityKindsQueryProvider: AbilityKindsQueryProviderType = (props) => {
  const { children } = props;

  const { error, loading, data } = useQuery<AbilityKindsQueryType>(AbilityKindsQuery, {
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
